// Add JS class to HTML element for progressive enhancement
document.documentElement.classList.add('js');

// Main document ready function - consolidated for better performance
$(document).ready(function() {
  // Initialize sliders only if they exist in DOM
  initBannerSlider();
  initAccordion();
  initProductGallery();
  initAnimations();
  initReviewSlider();
  
  // Banner slider initialization with progress bar
  function initBannerSlider() {
    const $sliderContainer = $('.banner_slider');
    if (!$sliderContainer.length) return;
    
    const time = 2;
    let $bar, isPause, tick, percentTime;
    
    // Initialize slider with optimized settings
    $sliderContainer.slick({
      draggable: true,
      adaptiveHeight: true,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 15000,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      arrows: false
    });
    
    $bar = $('.slider-progress .progress');
    if (!$bar.length) return;
    
    function startProgressbar() {
      resetProgressbar();
      percentTime = 0;
      isPause = false;
      tick = setInterval(interval, 20);
    }
    
    function interval() {
      if (isPause === false) {
        percentTime += 1 / (time + 0.1);
        $bar.css({
          width: percentTime + "%"
        });
        if (percentTime >= 100) {
          $sliderContainer.slick('slickNext');
          startProgressbar();
        }
      }
    }
    
    function resetProgressbar() {
      $bar.css({
        width: 0 + '%'
      });
      clearTimeout(tick);
    }
    
    startProgressbar();
  }
  
  // Accordion functionality with optimized event delegation
  function initAccordion() {
    const $accordion = $(".set > a");
    if (!$accordion.length) return;
    
    // Use direct event binding for better reliability
    $(".set > a").on("click", function(e) {
      e.preventDefault();
      const $this = $(this);
      
      if ($this.hasClass("active")) {
        $this.removeClass("active")
             .siblings(".content")
             .slideUp(200);
        $(".set > a i")
             .removeClass("fa-minus")
             .addClass("fa-plus");
      } else {
        $(".set > a i")
             .removeClass("fa-minus")
             .addClass("fa-plus");
        $this.find("i")
             .removeClass("fa-plus")
             .addClass("fa-minus");
        $(".set > a").removeClass("active");
        $this.addClass("active");
        $(".content").slideUp(200);
        $this.siblings(".content")
             .slideDown(200);
      }
    });
  }
  
  // Product gallery initialization
  function initProductGallery() {
    const $rootSingle = $('.custom_featured_img');
    const $rootNav = $('.swiper-wrapper');
    
    if (!$rootSingle.length || !$rootNav.length) return;

    // Initialize product gallery sliders
    $rootSingle.slick({
      slide: '.cSlider__item',
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
      adaptiveHeight: true,
      infinite: false,
      useTransform: true,
      speed: 400,
      cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)'
    });

    $rootNav.on('init', function(event, slick) {
      $(this).find('.slick-slide.slick-current').addClass('is-active');
    })
    .slick({
      slide: '.cSlider__item',
      slidesToShow: 6,
      slidesToScroll: 6,
      dots: false,
      arrows: false,
      focusOnSelect: false,
      infinite: false,
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5
        }
      }, {
        breakpoint: 640,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      }]
    });

    $rootSingle.on('afterChange', function(event, slick, currentSlide) {
      $rootNav.slick('slickGoTo', currentSlide);
      $rootNav.find('.slick-slide.is-active').removeClass('is-active');
      $rootNav.find('.slick-slide[data-slick-index="' + currentSlide + '"]').addClass('is-active');
    });

    $rootNav.on('click', '.slick-slide', function(event) {
      event.preventDefault();
      var goToSingleSlide = $(this).data('slick-index');
      $rootSingle.slick('slickGoTo', goToSingleSlide);
    });
  }
  
  // Initialize animations with Scrolla plugin
  function initAnimations() {
    const $animatedElements = $('.animate');
    if (!$animatedElements.length) return;
    
    $animatedElements.scrolla({
      once: false,
      mobile: true
    });
  }
  
  // Initialize review slider
  function initReviewSlider() {
    const $reviewSlider = $('.review-top');
    if (!$reviewSlider.length) return;
    
    $reviewSlider.slick({
      dots: true,
      infinite: true,
      speed: 300,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: "<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0577/9495/3373/files/288898991556280995-32.png?v=1703154518'>",
      nextArrow: "<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0577/9495/3373/files/13582956511556280997-32.png?v=1703154520'>",
      fade: true,
      cssEase: 'linear',
      adaptiveHeight: true
    });
  }
});

// Scrolla plugin (minified)
!function(i){var t,n,a={init:function(i,o){t=i,n=o,a.bind()},bind:function(){i(window).scroll(function(){a.animate(t,n)}),i(window).trigger("scroll")},animate:function(t,n){var a=i(window).height(),o=i(window).scrollTop(),s=o+a;i.each(t,function(){var t=i(this).data("animate"),a=i(this).data("offset"),e=i(this).data("duration"),d=i(this).data("delay"),r=i(this).data("iteration"),h=i(this).outerHeight(),c=i(this).offset().top,l=c+h;a&&(c+=a,l-=a),i(this).css({"-webkit-animation-duration":e,"animation-duration":e}),i(this).css({"-webkit-animation-delay":d,"animation-delay":d}),i(this).css({"-webkit-animation-iteration-count":r,"animation-iteration-count":r}),l>=o&&c<=s?(i(this).css("visibility","visible"),i(this).addClass(t),i(this).addClass("animated")):n.once===!1&&(i(this).css("visibility","hidden"),i(this).removeClass(t),i(this).removeClass("animated"))})}};jQuery.fn.scrolla=function(t){return t=i.extend({mobile:!1,once:!1},t),(t.mobile!==!1||!/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))&&void a.init(this,t)}}(jQuery);
